import React, { useEffect } from "react";
import { useMap } from "@vis.gl/react-google-maps";
import { useSetShipPositionLoaded } from "../../hooks/useMapStore";
import MapApiRepository from "../../repositories/MapApiRepository";
import { isRequestAborted } from "../../../../helpers/ApiHelpers";
import { isArrayEmpty } from "components/helpers/ObjectHelpers";
import { useWarningNotification, AppNotificationSystemNames } from 'components/hooks/useAppStore';

export const MapShipMarker = ({ shipId, pilotageId }: { shipId: number, pilotageId: number }) => {

    const addWarningNotification = useWarningNotification();

    const map = useMap();
    const setShipPositionLoaded = useSetShipPositionLoaded();

    let shipPositionAbortController = new AbortController();

    const fetchPosition = async () => {

        shipPositionAbortController.abort();
        shipPositionAbortController = new AbortController();

        const response: any = await MapApiRepository.getShipPositionsAsync([shipId], shipPositionAbortController.signal);
        if (response.ok) {
            const data = await response.json();
            if (!isArrayEmpty(data)) {
                const position = new window.google.maps.LatLng(data[0].latitude, data[0].longitude);
                FitBounds(map, [position]);
            }

        } else {
            OnShipPositionResponseError(response, addWarningNotification);
        }

        setShipPositionLoaded();
    }

    useEffect(() => {
        if(shipId === 0 || pilotageId > 0) return;
        fetchPosition();
    }, [shipId, pilotageId]);

    return (null);
}

const FitBounds = (map:any, positions: any[]) => {
    if (!map) return;

    const bounds = new window.google.maps.LatLngBounds();
    for (const position of positions) {
        bounds.extend(position);
    }
    map.fitBounds(bounds);
}


const OnShipPositionResponseError = (response: any, addWarningNotification:any) => {
    if (isRequestAborted(response)) return;
    addWarningNotification("Kunne ikke finne fart&oslash;yets AIS posisjon.", AppNotificationSystemNames.MapAisFetchShipDataError);
}
